import React from 'react'
import { Divider } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ProductTypes } from '@/modules/base/util/constants'
import lang from '@/lang'
import LogoMainProduct from '@assets/images/icons/main_blue_white.svg'
import LogoDocumentProduct from '@assets/images/icons/document_blue_white.svg'
import LogoStaffProduct from '@assets/images/icons/staff_blue_white.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { UseDownloadContentProps, UseDownloadContentReturn } from './_shared'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  productTitleSM: {
    fontWeight: theme.fontWeights.medium,
    margin: 0,
  },
  productLogo: {
    width: 'auto',
    height: 40,
  },
  productTitle: {
    fontSize: theme.fontSizes.large,
    fontWeight: theme.fontWeights.medium,
    margin: 0,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
}))

export default function useDownloadContent({ activeSubscriptions, getStoreButtons }: UseDownloadContentProps): UseDownloadContentReturn {
  const isMain = activeSubscriptions.some(sub => sub === ProductTypes.MAIN)
  const isDocument = activeSubscriptions.some(sub => sub === ProductTypes.DOCUMENT)
  const isStaff = activeSubscriptions.some(sub => sub === ProductTypes.STAFF)
  const hasMainAndDocument = activeSubscriptions.includes(ProductTypes.MAIN) && activeSubscriptions.includes(ProductTypes.DOCUMENT)
  const classes = useStyles()

  const getContent = () => {
    const content = []
    if (hasMainAndDocument) {
      content.push(
        <div className={classes.section}>
          <div className={classes.sectionTitle}>
            <SVGIcon className={classes.productLogo} svg={LogoMainProduct} height='20px' />
          </div>
          <p dangerouslySetInnerHTML={{ __html: lang.appDeviceModal.mainAndDocument.visit }} />
          <p>{lang.appDeviceModal.mainAndDocument.download}</p>
          <Divider />
          <p className={classes.productTitleSM}>{lang.appDeviceModal.productTitles.main}</p>
          {getStoreButtons(ProductTypes.MAIN)}
          <Divider />
          <p className={classes.productTitleSM}>{lang.appDeviceModal.productTitles.document}</p>
          {getStoreButtons(ProductTypes.DOCUMENT)}
        </div>,
      )
    }
    if (isMain && !hasMainAndDocument) {
      content.push(
        <div className={classes.section}>
          <div className={classes.sectionTitle}>
            <SVGIcon className={classes.productLogo} svg={LogoMainProduct} height='30px' />
            <p className={classes.productTitle}>{lang.appDeviceModal.productTitles.main}</p>
          </div>
          <p dangerouslySetInnerHTML={{ __html: lang.appDeviceModal.main.visit }} />
          <p>{lang.appDeviceModal.main.download}</p>
          {getStoreButtons(ProductTypes.MAIN)}
        </div>,
      )
    }
    if (isDocument && !hasMainAndDocument) {
      content.push(
        <div className={classes.section}>
          <div className={classes.sectionTitle}>
            <SVGIcon className={classes.productLogo} svg={LogoDocumentProduct} height='30px' />
            <p className={classes.productTitle}>{lang.appDeviceModal.productTitles.document}</p>
          </div>
          <p dangerouslySetInnerHTML={{ __html: lang.appDeviceModal.document.visit }} />
          <p>{lang.appDeviceModal.document.download}</p>
          {getStoreButtons(ProductTypes.DOCUMENT)}
        </div>,
      )
    }

    if (isStaff) {
      content.push(
        <div className={classes.section}>
          <div className={classes.sectionTitle}>
            <SVGIcon className={classes.productLogo} svg={LogoStaffProduct} height='30px' />
            <p className={classes.productTitle}>{lang.appDeviceModal.productTitles.personal}</p>
          </div>
          <p dangerouslySetInnerHTML={{ __html: lang.appDeviceModal.staff.visit }} />
        </div>,
      )
    }

    return (
      <div className={classes.container}>
        {content}
      </div>
    )
  }

  return { getContent }
}
